var map = {
	"./arbetetsmuseum-1.jpg": 5670,
	"./arbetetsmuseum-2.jpg": 700,
	"./arbetetsmuseum-3.jpg": 2482,
	"./arbetetsmuseum-4.jpg": 5341,
	"./arbis-1.jpg": 5561,
	"./arbis-2.jpg": 8426,
	"./arbis-3.jpg": 2133,
	"./arkosundshotell-1.jpg": 4145,
	"./arkosundshotell-2.jpg": 8739,
	"./borgen-1.jpg": 4770,
	"./borgen-2.jpg": 9371,
	"./borgen-3.jpg": 9684,
	"./borgen-4.jpg": 2316,
	"./borgsruinen-1.jpg": 6298,
	"./borgsruinen-2.jpg": 3600,
	"./borgsruinen-3.jpg": 3262,
	"./bravalla-1.jpg": 6490,
	"./bravalla-2.jpg": 6177,
	"./bravalla-3.jpg": 8252,
	"./cnema-1.jpg": 8021,
	"./cnema-2.jpg": 8616,
	"./cnema-3.jpg": 8208,
	"./cnema-4.jpg": 995,
	"./de geer-0.jpg": 1510,
	"./de geer-1.jpg": 2069,
	"./de geer-2.jpg": 7677,
	"./evigheten-1.jpg": 8398,
	"./flygeln-1.jpg": 7945,
	"./flygeln-2.jpg": 2288,
	"./flygeln-3.jpg": 7421,
	"./grandhotell-1.jpg": 7702,
	"./grandhotell-2.jpg": 4773,
	"./grandhotell-3.jpg": 546,
	"./grandhotell-4.jpg": 5982,
	"./grandhotell-5.jpg": 2985,
	"./grandhotell-6.jpg": 6890,
	"./hallarna-1.jpg": 7591,
	"./hallarna-2.jpg": 5450,
	"./hallarna-3.jpg": 1629,
	"./harrys-1.jpg": 9336,
	"./harrys-2.jpg": 7545,
	"./harrys-3.jpg": 9596,
	"./hedvigskyrka-1.jpg": 5262,
	"./hedvigskyrka-2.jpg": 3686,
	"./hedvigskyrka-3.jpg": 1760,
	"./himmelstalundsfaltet-1.jpg": 4885,
	"./himmelstalundsfaltet-2.jpg": 6759,
	"./himmelstalundshallen-1.jpg": 748,
	"./himmelstalundshallen-2.jpg": 3407,
	"./holmentorget-1.jpg": 1584,
	"./horsalen-1.jpg": 9986,
	"./horsalen-2.jpg": 9141,
	"./horsalen-3.jpg": 3749,
	"./hugo-1.jpg": 8949,
	"./hugo-2.jpg": 133,
	"./hugo-3.jpg": 9639,
	"./idrottsparken-1.jpg": 6866,
	"./idrottsparken-2.jpg": 5464,
	"./idrottsparken-3.jpg": 7512,
	"./johannisborg-1.jpg": 4757,
	"./knappingsborg-1.jpg": 1418,
	"./knappingsborg-2.jpg": 6402,
	"./krakholmen-1.jpg": 281,
	"./krakholmen-2.jpg": 6131,
	"./lagerqvist-1.jpg": 3057,
	"./lagerqvist-2.jpg": 3425,
	"./lagerqvist-3.jpg": 3740,
	"./lejongropen-1.jpg": 9955,
	"./masshallarna-1.jpg": 2817,
	"./norrkoping-1.jpg": 2689,
	"./norrkoping-2.jpg": 8046,
	"./ostgotateatern-1.jpg": 337,
	"./ostgotateatern-2.jpg": 1710,
	"./ostgotateatern-3.jpg": 9324,
	"./rumpan bar-1.jpg": 7372,
	"./rumpan bar-2.jpg": 5869,
	"./stadiumarena-1.jpg": 9488,
	"./stadiumarena-2.jpg": 449,
	"./stadiumarena-3.jpg": 2808,
	"./stopet-1.jpg": 4571,
	"./stopet-2.jpg": 8660,
	"./tradgarn-1.jpg": 6742,
	"./tradgarn-2.jpg": 7138,
	"./varmekyrkan-1.jpg": 8590,
	"./varmekyrkan-2.jpg": 8775,
	"./varmekyrkan-3.jpg": 1184,
	"./vasaparken-1.jpg": 5765,
	"./vasaparken-2.jpg": 832,
	"./vildmarkshotellet-1.jpg": 4851,
	"./vildmarkshotellet-2.jpg": 6095,
	"./vildmarkshotellet-3.jpg": 3246,
	"./vildmarkshotellet-4.jpg": 1991,
	"./vildmarkshotellet-5.jpg": 1837,
	"./villafridhem-1.jpg": 3768,
	"./villafridhem-2.jpg": 3261,
	"./villafridhem-3.jpg": 7454,
	"./villafridhem-4.jpg": 7182,
	"./visualiseringscenter-1.jpg": 5100,
	"./visualiseringscenter-2.jpg": 14,
	"./visualiseringscenter-3.jpg": 8717,
	"./visualiseringscenter-4.jpg": 4112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;